<script setup lang="ts">
const STATS: Array<{
  value: string
  label: string
  valueIcon?: string
  labelIcon?: string
  labelIconAlt?: string
}> = [
  {
    value: '500+',
    label: 'landing.stats.restaurants.label',
  },
  {
    value: '30K',
    label: 'landing.stats.products.label',
    valueIcon: 'i-tabler-bowl-chopsticks-filled',
  },
  {
    value: '250K+',
    label: 'landing.stats.impressions.label',
    labelIcon: 'i-logos-google-icon',
    labelIconAlt: 'Google',
  },
  {
    value: '100K',
    label: 'landing.stats.pageviews.label',
  },
]
</script>

<template>
  <div class="bg-primary-900 w-full px-8 py-4 text-white">
    <div
      class="text-primary-200 mx-auto grid max-w-5xl grid-cols-2 gap-6 md:flex md:justify-between md:gap-8"
    >
      <div v-for="stat, i in STATS" :key="i" class="flex flex-col">
        <span class="flex gap-1 text-4xl font-bold">
          {{ stat.value }}
          <UIcon v-if="stat.valueIcon" :name="stat.valueIcon" aria-hidden="true" />
        </span>
        <span>
          <UIcon
            v-if="stat.labelIcon"
            :name="stat.labelIcon"
            class="mr-1 inline-block size-3.5 align-text-top"
            :role="stat.labelIconAlt ? 'img' : undefined"
            :aria-label="stat.labelIconAlt"
            :aria-hidden="stat.labelIconAlt ? undefined : true"
          />{{ $t(stat.label) }}
        </span>
      </div>
    </div>
  </div>
</template>
